import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import productbanner from '../Assets/Images/Blogs.avif';
import blog1 from '../Assets/Images/Blog2.png'
import blog2 from '../Assets/Images/Blog5.png'
import blog3 from '../Assets/Images/Blog3.png'
import blog4 from '../Assets/Images/Blog4.png'
import blog5 from '../Assets/Images/Blog1.png'

import { Helmet } from "react-helmet";


export const blogs = [
    {
        heading: "Blog1",
        img: blog1,
        title: "Top 10 Essential Mechanical Components for the Food, Dairy, and Pharmaceutical Industry",
        path: "/blog1",
      },
    {
        heading:"Blog2",
        img:blog2,
      title: "How to Choose the Right Mechanical Parts for High-Hygiene Applications",
      path: "/blog2",
    },
    {
        heading:"Blog3",
        img:blog3,
      title: "Why Quality Mechanical Parts Are Critical for Minimizing Downtime in Manufacturing",
      path: "/blog3",
    },
    {
        heading:"Blog4",
        img:blog4,
      title: "From Design to Delivery: The Journey of Custom Mechanical Parts at AIM Industrial Products",
      path: "/blog4",
    },
    {
        heading:"Blog5",
        img:blog5,
      title: "Mechanical Parts Maintenance Checklist for Food and Dairy Processing Plants",
      path: "/blog5",
    }
  ];

export default function Blogs() {
    
  return (
    <>
      <div className="mainnav">
      <Helmet>
        <title>Insights & Industry Blogs | AIM Industrial Products</title>

        <meta
          name="description"
          content="Explore expert insights, tips, and news on hygienic mechanical components for food, dairy, pharmaceutical, and automation industries from AIM Industrial Products."
        />
        <meta
          name="keywords"
          content="mechanical component blogs, industrial blog, food processing parts, dairy equipment tips, pharmaceutical manufacturing, hygienic mechanical parts, AIM blog, industry trends"
        />
        <meta name="author" content="AIM Industrial Products" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Blogs & Insights | AIM Industrial Products"
        />
        <meta
          property="og:description"
          content="Get valuable insights and expert advice on selecting, maintaining, and customizing mechanical components for regulated industries."
        />
        <meta
          property="og:image"
          content="https://yourdomain.com/assets/blog-banner.jpg" // Replace with your blog banner image
        />
        <meta property="og:url" content="https://aimindproducts.com/blogs" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Expert Blogs on Mechanical Components | AIM"
        />
        <meta
          name="twitter:description"
          content="Read top blogs on mechanical parts selection, maintenance, and industry best practices for pharma, food, and dairy."
        />
        <meta
          name="twitter:image"
          content="https://yourdomain.com/assets/blog-banner.jpg" // Replace with your blog banner
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://aimindproducts.com/blogs" />
      </Helmet>
        {/* Banner Section */}
        <div className="about-banner position-relative text-white mb-4">
          <img
            src={productbanner}
            alt="About Banner"
            className="aboutbanner-image animate-banner-zoom"
          />
          <div className="maindesc position-absolute top-50 start-50 translate-middle text-center px-3">
            <h2 className="fw-bold glitch" data-text="Blogs">
              Blogs
            </h2>
            <p>
    Explore our latest insights, tips, and news about mechanical components and industry trends.
  </p>
          </div>
        </div>
        <Container>
        <h2 className="Mainhead">Top Mechanical Blog Picks</h2>
        <Row>
  {blogs.map((blog, index) => (
    <Col key={index} md={4} className="mb-4">
      <Card className="h-100 border-1 shadow-lg blog-card-hover">
        <Card.Img variant="top" src={blog.img}  style={{height:'250px'}}/>
        <Card.Body className="d-flex flex-column justify-content-between">
          <div>
          <h4 style={{color:'#004BA5'}}>{blog.heading}</h4>
            <h6>{blog.title}</h6>
          </div>
          <div className="text-center mt-0">
            <Link to={blog.path}>
              <Button variant="primary"
              style={{background:'none',
                border:'none',
                color:'#004BA5',
                fontWeight:'bold'}}
              >
                Learn More
                </Button>
            </Link>
          </div>
        </Card.Body>
      </Card>
    </Col>
  ))}
</Row>

        </Container>
       
       
      </div>
    </>
  );
}
